import { render, staticRenderFns } from "./OhmLawViz.vue?vue&type=template&id=62021efa&scoped=true"
import script from "./OhmLawViz.vue?vue&type=script&lang=js"
export * from "./OhmLawViz.vue?vue&type=script&lang=js"
import style0 from "./OhmLawViz.vue?vue&type=style&index=0&id=62021efa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62021efa",
  null
  
)

export default component.exports